var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"v-switch",class:_vm.classes,on:{"click":function($event){return _vm.handleInput(!_vm.value)}}},[_c('span',{staticClass:"v-switch__mark"})])}
var staticRenderFns = []

export { render, staticRenderFns }